export default __webpack_public_path__ + "static/book-cover-f369343ffb0fc3ce9858f3effe2540bc.png";